import { QualifiedData } from "../qualified"
import analyticsAction from "./analytics-action"
import setUserProperties from "./analytics-identify"

export default function analyticsQualified(name: string, data: QualifiedData) {
  // Standard Qualified events and our custom events are capitalised with spaces
  const formattedName = name.toLowerCase()
  const userProperties: Record<string, string | number> = {
    "First name": data.field_values.first_name,
    "Last name": data.field_values.last_name,
    Email: data.field_values.email,
    Company: data.field_values.company,
    Phone: data.field_values.phone,
  }

  Object.keys(userProperties).forEach(
    key => userProperties[key] === undefined && delete userProperties[key]
  )

  const amplitudeData: Record<string, string | number> = {
    "Qualified experience": data.bot.name,
    "Qualified playback url": data.field_values.playback_url,
    "Job title": data.field_values.title,
    "Number of employees": data.field_values.employee_range,
    ...userProperties,
  }

  setUserProperties(userProperties)

  analyticsAction(`Qualified ${formattedName}`, amplitudeData)
}
